import { HashRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Formations from "@/pages/Formations";
import Tarifs from "@/pages/Tarifs";
import Contact from "@/pages/Contact";
import Inscription from "@/pages/Inscription";

function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/formations" element={<Formations />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/inscription" element={<Inscription />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}

export default App;
